<script setup lang="ts">
import ButtonBase, { type ButtonBaseProps } from "@/components/BaseButton.vue";

const props = withDefaults(
  defineProps<ButtonBaseProps & { dark?: boolean }>(),
  {
    rounded: true,
    shadow: true,
  }
)
</script>

<template>
  <ButtonBase :class="[$style['button-primary'], { [$style.dark]: dark }]" class="btn-primary" v-bind="props">
    <slot />
  </ButtonBase>
</template>

<style module lang="scss">
@import "@/assets/variables";
@import "@/assets/bootstrap-variables";

.button-primary {
  --#{$prefix}btn-bg: #{$primary};
  --#{$prefix}btn-hover-bg: #345863;
}

.dark, [data-color-scheme="dark"] .button-primary {
  box-shadow: #fff 0 0 10px 0;
}

</style>